<template>
  <v-draggable>
    <v-window ref="window" defaultClosed :class="$style.wrapper" width="84rem" title="Browser">
      <transition name="mobile-slide" appear>
        <div v-if="stage === 0" :key="1">
          <div :class="$style.top">
            <svg width="68" height="41" viewBox="0 0 68 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M66.5 20.5C66.5 25.4307 63.178 30.1472 57.2671 33.7111C51.385 37.2577 43.1624 39.5 34 39.5C24.8376 39.5 16.615 37.2577 10.7329 33.7111C4.82202 30.1472 1.5 25.4307 1.5 20.5C1.5 15.5693 4.82202 10.8528 10.7329 7.28888C16.615 3.7423 24.8376 1.5 34 1.5C43.1624 1.5 51.385 3.7423 57.2671 7.28888C63.178 10.8528 66.5 15.5693 66.5 20.5Z" stroke="#16B9FF" stroke-width="3"/>
              <path d="M26.016 24.424H21.312L20.432 27H18.48L22.512 15.8H24.816L28.832 27H26.896L26.016 24.424ZM25.456 22.776L23.792 17.848H23.536L21.872 22.776H25.456ZM33.9995 27.192C33.1568 27.192 32.4048 27.032 31.7435 26.712C31.0928 26.3813 30.5808 25.896 30.2075 25.256C29.8342 24.616 29.6475 23.8427 29.6475 22.936V15.8H31.4715L31.4875 22.936C31.4875 23.7253 31.7222 24.344 32.1915 24.792C32.6608 25.24 33.2635 25.464 33.9995 25.464C34.7355 25.464 35.3382 25.24 35.8075 24.792C36.2768 24.344 36.5115 23.7253 36.5115 22.936V15.8H38.3355V22.936C38.3355 23.8427 38.1488 24.616 37.7755 25.256C37.4022 25.896 36.8848 26.3813 36.2235 26.712C35.5728 27.032 34.8315 27.192 33.9995 27.192ZM44.5769 15.8C45.6222 15.8 46.5235 16.0293 47.2809 16.488C48.0489 16.9467 48.6355 17.5973 49.0409 18.44C49.4569 19.2827 49.6649 20.2693 49.6649 21.4C49.6649 22.5307 49.4569 23.5173 49.0409 24.36C48.6355 25.2027 48.0489 25.8533 47.2809 26.312C46.5235 26.7707 45.6222 27 44.5769 27H40.2569V15.8H44.5769ZM44.4809 25.352C45.5795 25.352 46.4062 24.9893 46.9609 24.264C47.5262 23.528 47.8089 22.5733 47.8089 21.4C47.8089 20.2267 47.5262 19.2773 46.9609 18.552C46.4062 17.816 45.5795 17.448 44.4809 17.448H42.0649V25.352H44.4809Z" fill="#16B9FF"/>
            </svg>
            <span :class="$style.avatar">Скобец <img src="./assets/Skobetc.svg" alt=""></span>
          </div>
          <div :class="$style.title">Анализатор утечки данных</div>
          <div :class="[$style.form, form.checked && $style.checked]">
            <div :class="$style.inner">
              <v-select :items="form.items" v-model="form.selected" placeholder="Выбери почтовый ящик" />
              <v-btn v-if="form.selected" large color="green" @click="check" :disabled="form.checked">ПРОВЕРИТЬ</v-btn>
            </div>
            <div :class="$style.formSubline" v-if="form.checked">
              Логин и пароль стали общедоступными <br> с этих сайтов: abc***games.ru, <br> tuti****.ru, poch***at.com.
            </div>
            <div :class="[$style.formSubline, $style.formSublineOk]" v-if="form.isOk">
              Данные в безопасности
            </div>
          </div>
          <transition name="bounce">
            <v-btn v-if="form.checked" large color="green" @click="next">Далее</v-btn>
          </transition>
        </div>
        <div v-else :class="$style.browser" :key="2">
          <transition name="mobile-slide" appear>
            <div v-if="!browser.site" :class="$style.sites">
              <site @open="openSite" :index="0" :site="browser.sites[0]"><img src="./assets/games.svg" alt=""></site>
              <site @open="openSite" :index="1" :site="browser.sites[1]"><img src="./assets/seti.svg" alt=""></site>
              <site @open="openSite" :index="2" :site="browser.sites[2]"><img src="./assets/mail.svg" alt=""></site>
            </div>
            <oneSite v-else :sites="browser.sites" :site="browser.site" @close="closeSite" />
          </transition>
        </div>
      </transition>
    </v-window>
  </v-draggable>
</template>
<script>
import site from './site'
import oneSite from './one-site'

export default {
  name: 'browser',
  components: { site, oneSite },
  props: {
    data: Object,
  },
  data() {
    return {
      stage: 0,
      form: {
        selected: false,
        checked: false,
        isOk: false,
        items: [
          {
            label: 'skobec@poc****at.com',
            value: 'skobec@pochtacat.com',
            right: true,
          },
          {
            label: 'skobec2005@***pochta.su',
            value: 'skobec2005@etopochta.su',
            right: false,
          },
          {
            label: 'superman@super*****.ru',
            value: 'superman@superpochta.ru',
            right: false,
          },
        ],
      },
      browser: {
        sites: this.data.sites,
        site: null,
      },
    }
  },
  methods: {
    open() {
      this.$refs.window.open()
      this.data.tasks[0].current = true
      if (this.stage === 1) {
        this.data.tasks[1].current = true
        this.data.tasks[2].current = true
        this.data.tasks[3].current = true
        this.data.tasks[4].current = true
        this.data.tasks[5].current = true
        this.data.tasks[6].current = true
        this.data.tasks[7].current = true
      }

      if (this.stage === 0) {
        this.$emit('box', 'box1')
      }
      if (this.stage === 1) {
        this.$emit('box', 'box2')
      }
    },
    close() {
      this.$refs.window.close()
      this.data.tasks[0].current = false
      if (this.stage === 1) {
        this.data.tasks[1].current = false
        this.data.tasks[2].current = false
        this.data.tasks[3].current = false
        this.data.tasks[4].current = false
        this.data.tasks[5].current = false
        this.data.tasks[6].current = false
        this.data.tasks[7].current = false
      }
    },
    next() {
      this.stage += 1
      this.$emit('box', 'box2')
      this.data.tasks[1].current = true
      this.data.tasks[2].current = true
      this.data.tasks[3].current = true
      this.data.tasks[4].current = true
      this.data.tasks[5].current = true
      this.data.tasks[6].current = true
      this.data.tasks[7].current = true
    },
    check() {
      this.form.isOk = false
      if (this.form.selected.right) {
        this.form.checked = true
        this.data.tasks[0].ready = true
        this.$store.commit('SET_RESULT', 5)
      } else {
        this.form.isOk = true
      }
    },
    openSite(index) {
      this.browser.site = this.browser.sites[index]
    },
    closeSite() {
      this.browser.site = null
      this.checkSites()
    },

    // ------ //
    checkSites() {
      const { sites } = this.browser
      if (sites.filter(item => item.ready).length === sites.length) {
        this.close()
        this.data.tasks[1].ready = true
        this.data.tasks[2].ready = true
        this.data.tasks[3].ready = true
        this.data.tasks[4].ready = true
        this.data.tasks[5].ready = true
        this.data.tasks[6].ready = true
        this.data.tasks[7].ready = true
        this.$store.commit('SET_RESULT', 5)
        this.$emit('success')
      }
    },
  },
}
</script>
<style lang="scss" module>
.wrapper {
  left: 33.2rem;
  top: 8.7rem;
  height: 56.1rem;
}
.top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4rem;

  & > svg {
    width: 6.8rem;
    height: auto;
  }
}

.avatar {
  display: flex;
  align-items: center;

  img {
    width: 5rem;
    height: auto;
    margin-left: 1rem;
  }
}

.title {
  color: #16B9FF;
  margin-bottom: 2rem;
  text-align: center;
}

.form {
  background: #F0F0F5;
  width: 59.1rem;
  height: 26rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4rem;
  margin-bottom: 2rem;

  & + button {
    margin: 0 auto;
    display: block;
  }

  button {
    margin-left: 1rem;
  }

  &.checked {
    box-shadow: 0 0 0 0.3rem inset #ff0000;

    .select {
      color: #ff0000;
    }
  }
}

.inner {
  display: flex;
  justify-content: center;
  align-items: center;
}
.formSubline {
  color: #ff0000;
  margin-top: 3rem;
  text-align: center;
  font-size: 1.6rem;
}

.formSublineOk {
  color: #09E56E;
}

.browser {
  height: 100%;
  overflow: hidden;
}
.sites {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
  padding-top: 1.5rem;
}
</style>
